import React, { useRef, useState } from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    TextField,
    Typography,
    Link,
    Paper,
    Alert,
    Snackbar,
} from '@mui/material';
import { register, verifyotp } from '../services';
import { useLocation, useNavigate } from 'react-router-dom';
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from '../context/AuthContext';
const OtpVerification = () => {
    const { login } = useAuth();
    const [otpValues, setOtpValues] = useState(["", "", "", ""]);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef([]);
    const location = useLocation();
    const formData = location.state;
    const handleChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return; // Only allow single digit (0-9)

        const newOtp = [...otpValues];
        newOtp[index] = value;
        setOtpValues(newOtp);

        // Move to next field if digit is entered
        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otpValues[index] === "" && index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        }
    };
    const handleSnackbarClose = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };
    const handleSubmit = async () => {
        const otp = otpValues.join("");
        setIsLoading(true);
        try {
            const otpRes = await verifyotp({ email: formData.email, otp });
            if (otpRes.status === 200) {
                const registerRes = await register(formData);
                if (registerRes.status === 200) {
                    const { token, user_type, data } = registerRes.data;
                    localStorage.setItem("token", token);
                    const logindata = registerRes.data;
                    login(user_type, logindata);
                    navigate("/home");
                    setSnackbar({
                        open: true,
                        message: "Registration successful!",
                        severity: "success",
                    });
                } else {
                    setIsLoading(false)
                    throw new Error("Registration failed. Please try again.");
                }
            } else {
                setIsLoading(false)
                throw new Error("OTP verification failed. Please try again.");
            }
        } catch (error) {
            setIsLoading(false)
            const errMsg =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            console.error("Error:", error);

            setSnackbar({
                open: true,
                message: errMsg,
                severity: "error",
            });
        }
    };
    return (
        <>
            <Box
                sx={{
                    minHeight: '100vh',
                    background: "linear-gradient(to right, #0f9ba1, #8ee3a8)",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    padding: 2,
                }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        padding: 4,
                        borderRadius: 3,
                        width: '100%',
                        maxWidth: 500,
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h5" fontWeight={600} color='rgba(84, 84, 84, 1)' gutterBottom>
                        OTP Verification
                    </Typography>

                    <Typography variant="body1" color='rgba(102, 102, 102, 1)' gutterBottom>
                        Enter the code verification sent to
                    </Typography>

                    <Typography variant="subtitle1" color='rgba(102, 102, 102, 1)' fontWeight={500}>
                        {formData.email}
                    </Typography>

                    <Typography
                        variant="caption"
                        display="block"
                        mt={2}
                        mb={1}
                        color='rgba(102, 102, 102, 1)'
                    >
                        Type 4 digit security code
                    </Typography>
                    <Grid container spacing={2} justifyContent="center">
                        {[0, 1, 2, 3].map((_, index) => (
                            <Grid item key={index}>
                                <TextField
                                    inputRef={(el) => (inputRefs.current[index] = el)}
                                    variant="outlined"
                                    value={otpValues[index]}
                                    onChange={(e) => handleChange(e.target.value, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    inputProps={{
                                        maxLength: 1,
                                        style: {
                                            textAlign: "center",
                                            fontSize: "1.5rem",
                                            width: "50px",
                                            height: "50px",
                                        },
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <Button
                        variant="contained"
                        sx={{
                            mt: 3,
                            background: 'linear-gradient(90deg, #0172AF 0%, #74FEBD 100%)',
                            color: '#fff',
                            paddingX: 5,
                            paddingY: 1.5,
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            borderRadius: 2,
                        }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <CircularProgress size={24} sx={{ color: "white" }} />
                        ) : (
                            "Verify"
                        )}
                    </Button>
                </Paper>
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default OtpVerification;
